import { route } from "preact-router";
import docCookies from "../cookiestore";

const ACCESS_TOKEN_KEY = "access_token";
const EXPIRES_IN = "expires_in";
const CLIENT_ID = 1;
const CLIENT_SECRET = "pie8Eu2JmeanoJe6ab2eiCaekeiGooD6";
const urllogin =
  "https://shopify.ilpt.de/api/access_token?shop=ilptbook.myshopify.com";
const urlregister =
  "https://shopify.ilpt.de/api/apps/?shop=ilptbook.myshopify.com";
const urlfetch =
  "https://shopify.ilpt.de/api/apps/me?shop=ilptbook.myshopify.com";
const urlreset =
  "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com&product=mwp-ebook";
const urlresetexec =
  "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com";

// https://auth0.com/blog/preact-authentication-tutorial/
// https://preact.gitbooks.io/react-book/content/flux/auth.html

const isSupported = () => {
  try {
    const key = "__some_random_key_you_are_not_going_to_use__";
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    console.log("ls");
    return localStorage;
  } catch (e) {
    console.log("ls issue");
  }
  try {
    const key2 = "__some_other_random_key_you_are_not_going_to_use__";
    sessionStorage.setItem(key2, key2);
    sessionStorage.removeItem(key2);
    console.log("ss");
    return sessionStorage;
  } catch (e) {
    console.log("ss issue, going for cookie");
    return docCookies;
    // cookieStorage
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie/Simple_document.cookie_framework
  }
};

const prefix = isSupported();

export function register(email, password, token, cb, that) {
  let res = false;

  const obj = {
    email,
    password,
    token
  };

  // console.log("obj reg", obj);

  const init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  fetch(urlregister, init)
    .then(response => {
      // console.log(response);
      if (response.ok) {
        // console.log('ok');
        return response.json();
      }
      // throw new TypeError("Oops, we haven't got JSON!");
      console.log("registration not successful");
      console.log(response.status); // 400 for wrong credentials
      res = true;
      cb(res, that);
    })
    .then(json => {
      if (json) {
        console.log("json success", json);
        res = false;
        cb(res, that);
      }
    })
    .catch(err => {
      console.log("err", err);
      res = true;
      cb(res, that);
    });

  return res;
}

export function login(username, password, cb, that, gender) {
  let res = false;

  const obj = {
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    grant_type: "password",
    username,
    password
  };

  const init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  function cb2(res) {
    console.log("cb2 issue? ", res);
    console.log("routing to dash ...");
    route("/" + gender + "/dash");
  }

  fetch(urllogin, init)
    .then(response => {
      // console.log(response);
      if (response.ok) {
        // console.log('ok');
        return response.json();
      }
      // throw new TypeError("Oops, we haven't got JSON!");
      console.log("login not successful");
      console.log(response.status); // 400 for wrong credentials
      res = true;
      cb(res, that);
    })
    .then(json => {
      if (json) {
        // successful login
        // console.log('json', json);
        setAccessToken(json.access_token);
        setExpiry(json.expires_in);
        syncLocalStorage(cb2);
      }
    })
    .catch(err => {
      console.log("err", err); // catching when no internet connection
      res = true;
      cb(res, that);
    });
  // console.log('login initiated');
  return;
}

export function pwreset(email, cb, that) {
  let res = false;

  const obj = {
    email
  };

  const init = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  fetch(urlreset, init)
    .then(response => {
      // console.log(response);
      if (response.ok) {
        console.log("reset initiiated");
        cb(res, that);
        return;
      }
      // throw new TypeError("Oops, we haven't got JSON!");
      console.log("reset not successful");
      res = true;
      cb(res, that);
    })
    .catch(err => {
      console.log("err", err);
    });

  return;
}

export function resetExec(password, token, cb, that) {
  let res = false; // error?

  const obj = {
    password,
    password_reset_token: token
  };

  const init = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  };

  fetch(urlresetexec, init)
    .then(response => {
      // console.log(response);
      if (response.ok) {
        console.log("resetexec initiiated");
        cb(res, that);
        return;
      }
      // throw new TypeError("Oops, we haven't got JSON!");
      console.log("resetexec not successful");
      console.log("response.status", response.status);
      console.log("response.statusText ", response.statusText);
      res = true;
      cb(res, that);
    })
    .catch(err => {
      console.log("err", err);
    });

  return;
}

export function logout(gender) {
  clearAccessToken();
  route("/" + gender);
}

export function getAccessToken() {
  if (typeof window !== "undefined") {
    return prefix.getItem(ACCESS_TOKEN_KEY);
  }
}

export function getExpiry() {
  if (typeof window !== "undefined") {
    return prefix.getItem(EXPIRES_IN);
  }
}

export function setLs(item, data) {
  if (typeof window !== "undefined") {
    prefix.setItem(item, data);
    console.log("ls set");
    return;
  }
}

export function getLs(item) {
  // console.log("pref1", prefix);
  if (typeof window !== "undefined") {
    // console.log("pref2", prefix);
    const res = prefix.getItem(item);
    return res;
  }
}

export function syncLocalStorage(cb) {
  const bearer = "Bearer " + getAccessToken();
  const init = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer
    }
  };

  fetch(urlfetch, init)
    .then(response => {
      if (response.ok) {
        // console.log("response ok for GET");
        return response.json();
      }
      // console.log("data pull not successful");
      // console.log(response.status);
      // wrong token means 401
      if (response.status === 401) cb(401);
      else {
        cb(true);
      }
    })
    .then(jsonraw => {
      if (jsonraw) {
        // console.log('json?', jsonraw);
        const json = JSON.parse(jsonraw.payload);
        // console.log('payload', json);
        const getTimeLocalStorage = () => {
          return prefix.getItem("update_state");
        };

        const timeLocalStorage = getTimeLocalStorage();

        const timeFromAPI = json.update_state;
        // console.log("times", timeLocalStorage, timeFromAPI);

        if (timeLocalStorage > timeFromAPI) {
          // console.log("ls is fresh");
          updateApiData(cb);
        } else if (timeLocalStorage === timeFromAPI) {
          // console.log("both fresh. NoOP");
          cb(false);
        } else {
          // console.log("api is fresher");
          if (json.state && json.update_state) {
            prefix.setItem("state", json.state);

            prefix.setItem("update_state", json.update_state);

            // console.log("ls refreshed");
            cb(false);
          } else {
            // console.log("issue with API data. LS update not successful");
            cb(true);
          }
        }
      }
    })
    .catch(err => {
      console.log("err", err);
      // typically no internet connection
      cb(true);
    });
}

export function updateApiData(cb) {
  let res = false; // no error
  const bearer = "Bearer " + getAccessToken();

  const getLsState = () => {
    return prefix.getItem("state");
  };

  const lsState = getLsState();

  const getLsUpdate = () => {
    return prefix.getItem("update_state");
  };

  const lsUpdate = getLsUpdate();

  // console.log("updateAPI lsState", lsState);
  // console.log("updateAPI lsUpdate", lsUpdate);

  if (!lsState || !lsUpdate) {
    console.log("LS Data not available");
    res = true;
    cb(res);
    return;
  }

  const payload = JSON.stringify({ state: lsState, update_state: lsUpdate });

  const obj = {
    payload
  };

  const init = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer
    },
    body: JSON.stringify(obj)
  };

  fetch(urlfetch, init)
    .then(response => {
      // console.log(response);
      if (response.ok) {
        // console.log("response ok for PUT");
        return response.json();
      }
      // throw new TypeError("Oops, we haven't got JSON!");
      // console.log("data put not successful");
      res = true;
      cb(res);
    })
    .then(json => {
      // console.log("through");
      if (json) {
        // console.log("json???", json);
        // console.log("API update done. before nested callback");
        cb(res);
      }
    })
    .catch(err => {
      // console.log("err", err);
      res = true;
      cb(res);
    });
}

function clearAccessToken() {
  if (typeof window !== "undefined") {
    prefix.removeItem(ACCESS_TOKEN_KEY);
  }
}

export function setAccessToken(token) {
  if (typeof window !== "undefined") {
    prefix.setItem(ACCESS_TOKEN_KEY, token);
  }
}

export function setExpiry(token) {
  if (typeof window !== "undefined") {
    prefix.setItem(EXPIRES_IN, token);
  }
}

export function getGender() {
  if (typeof window !== "undefined") {
    const gen = prefix.getItem("gender");
    return gen ? gen : "women";
  }
  console.log("bust");
}

export function setGender(gender) {
  if (typeof window !== "undefined") {
    // console.log("pre gender", prefix);

    prefix.setItem("gender", gender);
  }
}

export function isLoggedIn() {
  const bearerToken = getAccessToken();
  const expiry = getExpiry();
  return !!bearerToken && !isTokenExpired(expiry);
}

function getTokenExpirationDate(encodedToken) {
  const exp = encodedToken;
  if (!exp) {
    return null;
  }

  const date = new Date();
  date.setUTCSeconds(exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  const date = new Date();
  //console.log('expiration', expirationDate);
  //console.log('real date', date);
  return expirationDate < date;
}



// WEBPACK FOOTER //
// ./components/authstore/index.js